// Month translation utility
// Provides consistent month translations for both English and Arabic

export const monthTranslations = {
  en: {
    jan: 'Jan', feb: 'Feb', mar: 'Mar', apr: 'Apr', may: 'May', jun: 'Jun',
    jul: 'Jul', aug: 'Aug', sep: 'Sep', oct: 'Oct', nov: 'Nov', dec: 'Dec'
  },
  ar: {
    jan: 'ينا', feb: 'فبر', mar: 'مار', apr: 'أبر', may: 'ماي', jun: 'يون',
    jul: 'يول', aug: 'أغس', sep: 'سبت', oct: 'أكت', nov: 'نوف', dec: 'ديس'
  }
};

/**
 * Get translated month name
 * @param {string} monthKey - Month key (jan, feb, etc.)
 * @param {string} language - Language code (en, ar)
 * @returns {string} Translated month name
 */
export const getMonthTranslation = (monthKey, language = 'en') => {
  const key = monthKey.toLowerCase();
  return monthTranslations[language]?.[key] || monthTranslations.en[key] || monthKey;
};

/**
 * Get month name from date with proper translation
 * @param {Date} date - Date object
 * @param {string} language - Language code (en, ar)
 * @returns {string} Translated month name
 */
export const getMonthFromDate = (date, language = 'en') => {
  const monthKey = date.toLocaleString('en', { month: 'short' }).toLowerCase();
  return getMonthTranslation(monthKey, language);
};

/**
 * Get month name with fallback to native locale
 * @param {Date} date - Date object
 * @param {string} language - Language code (en, ar)
 * @param {Function} t - Translation function (optional)
 * @returns {string} Translated month name
 */
export const getMonthWithFallback = (date, language = 'en', t = null) => {
  const monthKey = date.toLocaleString('en', { month: 'short' }).toLowerCase();
  
  // Try translation function first
  if (t) {
    const translation = t(`months.${monthKey}`);
    if (translation && translation !== `months.${monthKey}`) {
      return translation;
    }
  }
  
  // Use our translation map
  const translated = getMonthTranslation(monthKey, language);
  if (translated && translated !== monthKey) {
    return translated;
  }
  
  // Fallback to native locale
  return date.toLocaleString(language === 'ar' ? 'ar-SA' : 'en-US', { month: 'short' });
}; 